import SomethingWentWrong from "../../messages/SomethingWentWrong";
import Layout from "../../Layout";

interface ErrorPageProps {
  user;
  idToken;
  isToUseAuthZero?;
  isAuthenticated?;
  logoutUrl?;
}

const ErrorPage = ({
  user,
  idToken,
  isAuthenticated,
  isToUseAuthZero,
  logoutUrl,
}: ErrorPageProps) => {
  return (
    <Layout
      user={user}
      idToken={idToken}
      isAuthenticated={isAuthenticated}
      isToUseAuthZero={isToUseAuthZero}
      logoutUrl={logoutUrl}
    >
      <SomethingWentWrong onRetryClick={() => window.location.reload()} />
    </Layout>
  );
};

export default ErrorPage;
